import React, {FC} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {RoundButton} from '@optimaxdev/design-system';
import classNames from 'classnames';

import {CART_UPGRADE_UPGRADES_LEARN_MORE_POPUP_USAGE} from 'constants/analytics/events/cartUpgrade';
import {spawnPriorityTask} from 'libs/timers/spawnPriorityTask/spawnPriorityTask';

import s from './coatingPopupContent.scss';

type PopupsType = {
    [key: string]: {
        title: string;
        description: React.ReactNode;
        btnName: string;
        analyticEventLabel: string;
        imageClassName: string;
    };
};

const POPUPS: PopupsType = {
    digitalBlock: {
        analyticEventLabel: 'Blue Light',
        btnName: 'Add Blue Light Coating',
        description: (
            <>
                Nearly 70% of American adults experience eye strain, blurred vision, red eyes or
                migraines due to prolonged use of the digital devices and the exposure to blue
                light.
                <span className={s.digitalDescription}>
                    Blue Light lenses offer the best solution to deal with blue light emissions. The
                    lenses filter the blue light emitted by digital screens, providing comfort to
                    your eyes and protection from harmful rays.
                </span>
            </>
        ),
        imageClassName: s.digitalProtection,
        title: 'Blue Light Lenses',
    },
    hydrophobic: {
        analyticEventLabel: 'Super Hydrophobic',
        btnName: 'Add Hydrophobic Coating',
        description: (
            <>
                The Super Hydrophobic coating is the most effective way of keeping your lenses
                clean.
                <br />
                <br />
                The coating prevents liquid accumulation and smearing on the lens. Instead of
                clinging to the lens, water molecules cling to other molecules, forming droplets and
                rolling off the lens without leaving any smudges.
                <br />
                <br />
                It also repels grease and prevents fingerprint stains from appearing on the lens,
                making it much easier and quicker to clean.
            </>
        ),
        imageClassName: s.hydrophobic,
        title: 'Super Hydrophobic Coating',
    },
};

export type PropsType = {
    isSelected: boolean;
    handleClick: () => void;
    alias: string;
};

/**
 * Popup for coatings
 * @params {PropsType} - props
 * @returns {React.ReactElement} - rendered component
 */
export const CoatingPopupContent: FC<PropsType> = ({alias, handleClick, isSelected}) => {
    if (!(alias in POPUPS)) return null;

    const {analyticEventLabel, btnName, description, imageClassName, title} = POPUPS[alias];

    const addBtnClick = () => {
        handleClick();
        spawnPriorityTask(() => {
            sendDesktopAnalyticsEvent(CART_UPGRADE_UPGRADES_LEARN_MORE_POPUP_USAGE, {
                action: isSelected ? 'Remove' : 'Add',
                label: analyticEventLabel,
            });
        });
    };
    return (
        <div className={s.container}>
            <div className={s.leftSide}>
                <h3 className={s.title}>{title}</h3>
                <p className={s.description}>{description}</p>
                <div className={s.buttonWrapper}>
                    <RoundButton className={s.button} isFull={false} onClick={addBtnClick}>
                        {isSelected ? 'Added!' : btnName}
                    </RoundButton>
                </div>
            </div>
            <div className={classNames(s.image, imageClassName)} />
        </div>
    );
};
